module.exports = __webpack_public_path__ + "img/9788983925626.0ff17c79.jpg";